import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import httpService from "../../../../services/httpServices/httpServices";
import helpersNumbers from "../../../../helpers/numbers";
import helperSpinner from "../../../../helpers/spinner";
import StatePositionConstant from "./../StatePositionConstant";

export default function AllPositionInPage() {
  const params = useParams();
  const pageID = parseInt(params.pageID);
  const [positions, setPositions] = useState([]);
  const [page, setPage] = useState({});

  useEffect(() => {
    getPositions();
  }, []);

  useEffect(() => {
    if (!positions) {
      return;
    }
    getPage();
  }, [positions]);

  const getPage = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let page = await sendRequestGetPage(pageID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!page) {
      return;
    }
    setPage(page);
  };

  const sendRequestGetPage = async (pageID) => {
    const headersRequest = getHeaderRequest();
    let page;
    try {
      page = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/publisher/page/" +
          pageID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return page.data.data;
  };

  const getPositions = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const positions = await sendRequestGetPositions(pageID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!positions) {
      return;
    }

    setPositions(positions);
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetPositions = async (pageID) => {
    const headersRequest = getHeaderRequest();
    let positions;
    try {
      positions = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/publisher/position/page/" +
          pageID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return positions.data.data;
  };

  const generatePageDoseNotHaveAnyPositions = () => {
    return (
      <p className="alert alert-info">
        کاربر نمایش دهنده برای این صفحه هیچ جایگاهی نساخته است.
      </p>
    );
  };

  const getBadgeTypeClassStatePosition = (statePosition) => {
    let classNameBadgeType;
    switch (statePosition) {
      case StatePositionConstant.statusPosition.PENDING:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.statusPosition.REJECT_FROM_OPERATOR:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.statusPosition.SEND_SUGGESTION_TO_PUBLISHER:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.statusPosition.DISAGREE_FROM_PUBLISHER:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.statusPosition.AGREE_FROM_PUBLISHER:
        classNameBadgeType = "primary";
        break;
      case StatePositionConstant.statusPosition.CONFIRM:
        classNameBadgeType = "success";
        break;

      case StatePositionConstant.statusPosition
        .ALREADY_CONFIRMED_PENDING_FOR_EDIT:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.statusPosition
        .ALREADY_CONFIRMED_REJECT_FROM_OPERATOR_FOR_EDIT:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.statusPosition
        .ALREADY_CONFIRMED_SEND_SUGGESTION_TO_PUBLISHER_FOR_EDIT:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.statusPosition
        .ALREADY_CONFIRMED_DISAGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.statusPosition
        .ALREADY_CONFIRMED_AGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT:
        classNameBadgeType = "primary";
        break;
    }
    return classNameBadgeType;
  };

  const generatePositions = () => {
    return (
      <>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره جایگاه</td>
                <td>تعداد بنر در جایگاه</td>
                <td>مبلغ پایه</td>
                <td>مبلغ</td>
                <td>Hicoin بنر جایگزین</td>
                <td>اندازه (ارتفاع - عرض)</td>
                <td>وضعیت</td>
                <td>حالت</td>
                <td>تگ html جایگاه </td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {positions.map((position, index) => {
                return (
                  <tr>
                    <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                    <td>{helpersNumbers.toPersianNum(position.pop_id)}</td>
                    <td>{helpersNumbers.toPersianNum(position.pop_count)}</td>
                    <td className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(
                          position.pop_base_price
                        )
                      )}
                    </td>
                    <td className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(position.pop_price)
                      )}
                    </td>
                    <td className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(
                          position.pop_score_alternative
                        )
                      )}
                    </td>
                    <td style={{ letterSpacing: "2px" }}>
                      {helpersNumbers.toPersianNum(position.pop_size)}
                    </td>
                    <td>
                      <div dir="ltr" className="text-center">
                        {position.pop_active ? (
                          <span className="badge badge-success">فعال</span>
                        ) : (
                          <span className="badge badge-danger">غیرفعال</span>
                        )}
                      </div>
                    </td>
                    <td dir="ltr">
                      <span
                        className={` badge badge-${getBadgeTypeClassStatePosition(
                          position.pop_state
                        )} `}
                      >
                        {
                          StatePositionConstant.getStatusPositionString()[
                            position.pop_state
                          ]
                        }
                      </span>
                    </td>

                    <td dir="ltr">{position.pop_tag_html_id}</td>
                    <td>
                      {position.pop_tag_html_id && (
                        <span className="pl-2">
                          <button
                            className="btn btn-info"
                            onClick={(e) => {
                              e.preventDefault();
                              navigator.clipboard.writeText(
                                `<div class="hil-banner-advertise" id="${position.pop_tag_html_id}"></div>`
                              );
                              alert("تگ html کپی شد.");
                            }}
                          >
                            <i className="fas fa-copy"></i>
                          </button>
                        </span>
                      )}

                      <span className="pl-2">
                        <Link
                          to={`/position/manage/${position.pop_id}`}
                          className="btn btn-info"
                        >
                          <i className="fa fa-info"></i>
                        </Link>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title={`جایگاه های تبلیغاتی  `} />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to={`/page/manage/all/publisher/${page?.pap_web_site_publisher_id}`}
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {positions.length > 0
                ? generatePositions()
                : generatePageDoseNotHaveAnyPositions()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
